"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CUSTOMER_TAG = void 0;
exports.CUSTOMER_TAG = {
    ABANDONED_CART: 'ABANDONED_CART',
    PURCHASER: 'PURCHASER',
    CHARGEBACK: 'CHARGEBACK',
    AC_PURCHASER: 'AC_PURCHASER',
    MULTI_PURCHASER: 'MULTI_PURCHASER',
    SOFT_DECLINED: 'SOFT_DECLINED',
    HARD_DECLINED: 'HARD_DECLINED',
    READ_EMAILS: 'READ_EMAILS',
    EMAIL_BOUNCED: 'EMAIL_BOUNCED',
    CLICK_IN_EMAILS: 'CLICK_IN_EMAILS',
    AVAILABLE_BY_EMAIL: 'AVAILABLE_BY_EMAIL',
    EMAIL_DROPPED: 'EMAIL_DROPPED',
    REPORTED_AS_A_SPAM: 'REPORTED_AS_A_SPAM',
    UNSUBSCRIBED: 'UNSUBSCRIBED',
    AVAILABLE_BY_SMS: 'AVAILABLE_BY_SMS',
    UNSUBSCRIBED_SMS: 'UNSUBSCRIBED_SMS',
    HARD_DECLINED_SMS: 'HARD_DECLINED_SMS',
    SUBSCRIBED: 'SUBSCRIBED',
    UNSUBSCRIBED_EMAIL: 'UNSUBSCRIBED_EMAIL',
    VERIFIED: 'VERIFIED',
    ECOM_PURCHASER: 'ECOM_PURCHASER',
    LANDER_PURCHASER: 'LANDER_PURCHASER'
};
//# sourceMappingURL=customerTag.js.map